/** Per-workspace SDK client cache used by GlobalSDK.clientFor. */
export function createWorkspaceClientCache<T>(create: (directory: string) => T) {
  const cache = new Map<string, T>()
  return {
    clientFor(directory: string) {
      if (!directory) return undefined
      let cached = cache.get(directory)
      if (!cached) {
        cached = create(directory)
        cache.set(directory, cached)
      }
      return cached
    },
    has(directory: string) {
      return cache.has(directory)
    },
    size() {
      return cache.size
    },
    clear() {
      cache.clear()
    },
  }
}
